import { render } from "./AllFileCopy.vue?vue&type=template&id=d7136256"
import script from "./AllFileCopy.vue?vue&type=script&lang=js"
export * from "./AllFileCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__